import {FormatterBasic} from "./Core/FormatterBasic";

export class FileUploadFormatter extends FormatterBasic {
    Format(): string {
        return this.GetValue('URL');
    }

}